import { useEffect, useRef } from 'react';


const useIdleTimer = (onIdle, idleTime = 900000) => {
  const timerRef = useRef();

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(onIdle, idleTime);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "scroll", "touchstart"];

    const handleActivity = () => resetTimer();

    events.forEach(event => window.addEventListener(event, handleActivity));

    resetTimer(); // Start the initial timer

    return () => {
      clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, []);
};

export default useIdleTimer;


// const useIdleTimer = (onIdle, idleTime = 60000) => {
//   const timerRef = useRef(null);

//   const resetTimer = () => {
//     if (timerRef.current) clearTimeout(timerRef.current);
//     timerRef.current = setTimeout(() => {
//       onIdle(); // Call the logout or any function
//     }, idleTime);
//   };

//   useEffect(() => {
//     const activityEvents = ['mousemove', 'keydown', 'scroll', 'click'];

//     const handleActivity = () => {
//       resetTimer();
//     };

//     activityEvents.forEach((event) =>
//       window.addEventListener(event, handleActivity)
//     );

//     resetTimer(); // Start the timer initially

//     return () => {
//       activityEvents.forEach((event) =>
//         window.removeEventListener(event, handleActivity)
//       );
//       if (timerRef.current) clearTimeout(timerRef.current);
//     };
//   }, [idleTime, onIdle]);
// };

// export default useIdleTimer;
